import { useQueryState } from 'nuqs';

export const useFilter = (): any => {
  const [filterString, setFilterString] = useQueryState('filter');
  const filter = filterString ? JSON.parse(filterString) : {};

  const setFilter = async (
    appliedFilter: Record<string, string | string[]>,
  ): Promise<void> => {
    const appliedFilterString = JSON.stringify(appliedFilter);
    await setFilterString(appliedFilterString);
  };

  return { filter, setFilter };
};
